import { lazy } from 'react';

const ProductNavbar = lazy(
	() =>
		import(
			/* webpackChunkName: "product-navbar" */
			'./product-navbar.js'
		)
);

export default ProductNavbar;
